<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-05-28 13:37:50
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-05-30 15:02:16
 * @FilePath: \lightning\src\views\test\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <tr v-for="item in myTestList">
      <td
        class="hidden-m"
        align="center"
        width="13%"
        style="font-family:cfg_hm2uZ42WUT_1716875723553"
      >{{item.ql}}</td>
      <td
        class="hidden-m"
        align="center"
        width="13%"
        style="font-family:cfg_hm2uZ42WUT_1716875723553"
      >{{item.rvnm}}</td>
      <td
        class="hidden-m"
        align="center"
        width="13%"
        style="font-family:cfg_hm2uZ42WUT_1716875723553"
      >{{item.stcd}}</td>
      <td
        class="hidden-m"
        align="center"
        width="13%"
        style="font-family:cfg_hm2uZ42WUT_1716875723553"
      >{{item.stnm}}</td>
      <td
        class="hidden-m"
        align="center"
        width="13%"
        style="font-family:cfg_hm2uZ42WUT_1716875723553"
      >{{item.webStlc}}</td>
      <td
        class="hidden-m"
        align="center"
        width="13%"
        style="font-family:cfg_hm2uZ42WUT_1716875723553"
      >{{item.wrz}}</td>
      <td
        class="hidden-m"
        align="center"
        width="13%"
        style="font-family:cfg_hm2uZ42WUT_1716875723553"
      >{{item.zl}}</td>
    </tr>
  </div>
</template>

<script>
import test from "./test.json";

import html2canvas from "html2canvas";
export default {
  data() {
    return {
      testList: test,
      myTestList: []
    };
  },
  mounted() {
    console.log(this.testList);
    let nwwList = [];
    this.testList.map(item => {
      console.log(item);

      if (typeof item.ql != "number") {
        item.ql = item.ql.match(/otltag(\S*)#FontTag/)[1];
      }
      item.rvnm = item.rvnm.match(/otltag(\S*)/)[1];
      item.stcd = item.stcd.match(/otltag(\S*)#FontTag/)[1];
      item.stnm = item.stnm.match(/otltag(\S*)/)[1];
      item.webStlc = item.webStlc.match(/otltag(\S*)/)[1];
      if (typeof item.wrz != "number") {
        item.wrz = item.wrz.match(/otltag(\S*)#FontTag/)[1];
      }
      if (typeof item.zl != "number") {
        item.zl = item.zl.match(/otltag(\S*)#FontTag/)[1];
      }

      // return item;
      // console.log(item);
      nwwList.push(item);
    });
    console.log(nwwList);
    this.myTestList = nwwList;

    // setInterval(async () => {
    //   try {
    //     // 将网页内容转换为canvas元素
    //     const canvas = await html2canvas(document.body);

    //     // 将canvas元素转换为图片文件base64
    //     const img = canvas.toDataURL("image/png");

    //     // 图片文件img 处理上床后端
    //   } catch (error) {
    //     console.error("截图失败：", error);
    //   }
    // }, 10000);

    // str = str.match(/aaa(\S*)fff/)[1];
  }
};
</script>

<style>
@font-face {
  font-family: "cfg_hm2uZ42WUT_1716875723553";
  src: url("./Ue5P8NDL6Q_1717032492613.ttf");
}
</style>